import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';

import { TagModule } from 'primeng/tag';

@Component({
  selector: 'app-tag',
  standalone: true,
  imports: [CommonModule, TagModule],
  templateUrl: './tag.component.html',
})
export class TagComponent {
  // Core Content Properties
  public readonly content = input<string>('');
  public readonly displayContent = input<boolean>(true);
  public readonly emptyContentPlaceholder = input<string>('N/A');

  // Styling Related Properties
  public readonly textColor = input<string>('');
  public readonly backgroundColor = input<string>('');
  public readonly borderColor = input<string>('');
  public readonly tagInnerPadding = input<string>('');
  public readonly customClass = input<string>();

  // Icon and Shape Properties
  public readonly iconEnd = input<string>('');
  public readonly iconStart = input<string>('');
  public readonly roundedCorners = input<boolean>(false);

  // custom severity and style classes to hanlde the design system options
  public readonly severityClass = input<'secondary' | 'success' | 'info' | 'progress' | 'warning' | 'pending' | 'help' | 'danger'>('info');
  public readonly styleClass = input<'light' | 'bold'>('light');
  public readonly sizeClass = input<'tag-sm' | 'tag-md'>('tag-md');

  // Event Emitters
  readonly tagClick = output<MouseEvent>();

  handleClick(event: MouseEvent): void {
    this.tagClick.emit(event);
  }

  handleKeydown(event: KeyboardEvent): void {
    //requierd by sonarque
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault(); // Prevent space from scrolling the page
      this.tagClick.emit(event as any);
    }
  }
}
